(function () {
  function init(locator) {
    if (!locator || locator.dataset.jwlzInitialized === 'true') return;
    locator.dataset.jwlzInitialized = 'true';

    const params = new URLSearchParams(window.location.search);
    if (params.get('jwlz_ops') !== '1') return;

    locator.hidden = false;

    const status = locator.querySelector('[data-jwlz-ops-status]');
    const closeButton = locator.querySelector('[data-jwlz-ops-close]');
    const copyButton = locator.querySelector('[data-jwlz-copy-offer]');
    const offerId = locator.dataset.sourceOfferId || '';

    closeButton?.addEventListener('click', function () {
      locator.hidden = true;
    });

    copyButton?.addEventListener('click', async function () {
      if (!offerId) return;
      try {
        await navigator.clipboard.writeText(offerId);
        if (status) status.textContent = '1688 ID copied.';
      } catch (error) {
        if (status) status.textContent = 'Copy failed. Select the ID manually.';
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-jwlz-product-ops-locator]').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
